import { useState } from 'react';

const faqs = [
  {
    question: "What exactly is a LitBuy spreadsheet?",
    answer: "A LitBuy spreadsheet is an organized document — usually in Google Sheets or Excel format — that compiles product listings, seller information, pricing data, quality ratings, and direct purchase links from the LitBuy platform. It acts as your personal shopping assistant, centralizing all relevant product information into a single, searchable document across categories like shoes, hoodies, t-shirts, jackets, and more.",
  },
  {
    question: "Are LitBuy spreadsheets free to use?",
    answer: "Many LitBuy spreadsheets offer free basic access with essential category listings and seller information. Premium versions with advanced features like real-time updates, exclusive product finds, and detailed quality check photos are typically available for a small fee. The time savings alone usually justify any associated cost.",
  },
  {
    question: "How often are the spreadsheets updated?",
    answer: "Update frequency varies by spreadsheet creator. The best LitBuy spreadsheets are updated at least weekly, with some receiving daily updates during peak shopping seasons. Always check the last update date before relying on a spreadsheet for your shopping decisions.",
  },
  {
    question: "Can I trust the seller ratings in the spreadsheets?",
    answer: "While spreadsheet seller ratings are generally reliable — especially those from well-known community curators — you should always do your own verification. Check seller store ratings on LitBuy directly, read recent buyer reviews, and join community discussions to get the most complete picture of seller reliability.",
  },
  {
    question: "What product categories are available in LitBuy spreadsheets?",
    answer: "LitBuy spreadsheets typically cover a wide range of categories including Shoes, Hoodies and Sweaters, T-Shirts, Jackets, Pants and Shorts, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes, and more. Each category contains organized product listings with direct links, pricing, and seller information.",
  },
  {
    question: "How do LitBuy spreadsheets compare to manual searching?",
    answer: "LitBuy spreadsheets dramatically outperform manual searching in almost every aspect. They provide instant side-by-side price comparisons, pre-vetted sellers with community ratings, and one-click access to product pages. While manual searching can take hours per session, spreadsheets let you find what you need in minutes.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
            FAQ
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mt-3 leading-tight">
            Frequently Asked Questions
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            Everything you need to know about LitBuy spreadsheets and how to use them.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-50 transition-colors"
              >
                <span className="font-heading text-base md:text-lg font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <span className={`w-5 h-5 flex-shrink-0 flex items-center justify-center transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-600"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-4 md:pb-5 px-4 md:px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}